export default function LandingPreview({ slug }) {
  if (!slug) {
    return (
      <div style={emptyBox}>
        <strong>Preview da Landing</strong>
        <p>Selecione ou salve uma landing para visualizar o preview.</p>
      </div>
    );
  }

  return (
    <div style={previewBox}>
      <div style={previewHeader}>
        <strong>Preview ao vivo</strong>
        <a
          href={`https://ngs.adv.br/lp/${slug}`}
          target="_blank"
          rel="noreferrer"
          style={openLink}
        >
          Abrir em nova aba
        </a>
      </div>

      <iframe
        title="Preview da Landing"
        src={`https://ngs.adv.br/lp/${slug}`}
        style={iframeStyle}
      />
    </div>
  );
}

/* =========================
   ESTILOS
========================= */

const previewBox = {
  marginTop: 30,
  borderRadius: 12,
  overflow: "hidden",
  border: "1px solid #ddd",
  background: "#fff"
};

const previewHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 14px",
  background: "#0b0b0b",
  color: "#fff",
  fontSize: 14
};

const openLink = {
  color: "#25d366",
  textDecoration: "none",
  fontWeight: 600
};

const iframeStyle = {
  width: "100%",
  height: "600px",
  border: "none"
};

const emptyBox = {
  marginTop: 30,
  padding: 20,
  borderRadius: 12,
  background: "#f8f9fa",
  border: "1px dashed #ccc"
};
